import { useState, useEffect, useCallback } from 'react'
import { db } from '../lib/supabase'

export function useMeetings() {
  const [meetings, setMeetings] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const fetchMeetings = useCallback(async () => {
    setLoading(true)
    const { data, error } = await db.getMeetings()
    if (error) {
      setError(error)
    } else {
      setMeetings(data)
    }
    setLoading(false)
  }, [])

  useEffect(() => {
    fetchMeetings()
  }, [fetchMeetings])

  const createMeeting = async (meeting, decisions = [], actionItems = []) => {
    const { data, error } = await db.createMeeting(meeting)
    if (error || !data) return { data: null, error }

    for (const decision of decisions) {
      await db.createDecision({ ...decision, meeting_id: data.id })
    }

    for (const actionItem of actionItems) {
      await db.createActionItem({ ...actionItem, meeting_id: data.id })
    }

    await fetchMeetings()
    return { data, error: null }
  }

  return {
    meetings,
    loading,
    error,
    refetch: fetchMeetings,
    createMeeting,
  }
}

export default useMeetings
